// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-image-compare-[id]-js": () => import("./../../../src/pages/image-compare/[id].js" /* webpackChunkName: "component---src-pages-image-compare-[id]-js" */),
  "component---src-templates-types-page-js": () => import("./../../../src/templates/types/Page.js" /* webpackChunkName: "component---src-templates-types-page-js" */),
  "component---src-templates-types-post-js": () => import("./../../../src/templates/types/Post.js" /* webpackChunkName: "component---src-templates-types-post-js" */)
}

